/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_mobile_analytics_app_id": "b2a85b8b6aa649a987916bbfadaa6d86",
    "aws_mobile_analytics_app_region": "eu-west-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "b2a85b8b6aa649a987916bbfadaa6d86",
            "region": "eu-west-1"
        }
    },
    "aws_cloud_logic_custom": [
        {
            "name": "scans",
            "endpoint": "https://pkljh59wbc.execute-api.eu-west-2.amazonaws.com/production",
            "region": "eu-west-2"
        },
        {
            "name": "stripe",
            "endpoint": "https://4o4gk94rmg.execute-api.eu-west-2.amazonaws.com/production",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:add71add-68df-4625-9088-268ba1abd38f",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_MCAXaJQlN",
    "aws_user_pools_web_client_id": "2okmpa2so3sn6rmneojidtcidg",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "images150528-production",
    "aws_user_files_s3_bucket_region": "eu-west-2",
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "scans-production",
            "region": "eu-west-2"
        }
    ]
};


export default awsmobile;
